import {Formatter} from './units-formatter';

export class DefaultFormatter extends Formatter {
  apply(value: any): any {
    return value;
  }
}
